import { NylasMessageApi } from '../../../api/distributions/model/nylas-message.api';

export class NylasMessageModel {
    grantId: number;
    fromEmail: string;
    fromName: string;
    messageId: string;
    threadId: string;
    subject: string;
    body: string;
    toEmail: string;
    toName: string;
    date: Date;
    deliveryId: number;

    // F.E only
    expanded?: boolean = false;

    constructor(apiModel?: NylasMessageApi) {
        if (apiModel) {
            this.grantId = apiModel.grantId;
            this.fromEmail = apiModel.fromEmail;
            this.fromName = apiModel.fromName;
            this.messageId = apiModel.messageId;
            this.threadId = apiModel.threadId;
            this.subject = apiModel.subject;
            this.body = apiModel.body;
            this.toEmail = apiModel.toEmail;
            this.toName = apiModel.toName;
            // date comes in epoch seconds, Date takes epoch millis
            this.date = new Date(apiModel.date * 1000);
            this.deliveryId = apiModel.deliveryId;
        }
    }
}
